import {useMediaQuery} from '@malt/joy-entrypoint/src/vue/use';
import {computed} from 'vue';

/**
 * @returns This version is more or less the same than the one in nuxt-utils-module
 */
export function useDisplayMobile() {
    const {matchMedia} = useMediaQuery();
    const isDisplayMobile = computed<boolean>(() => matchMedia.value.max.Sm);

    return {
        isDisplayMobile,
    };
}
